<template>
  <div class="upload-container w-full">
    <div
      v-if="modelValue"
      class="relative w-full aspect-[4/3] bg-gray-100 rounded-lg overflow-hidden border shadow-sm"
    >
      <img
        :src="modelValue"
        class="w-full h-full object-contain"
        @click="handlePreview"
      />
      <div
        class="absolute top-2 right-2 bg-red-500 text-white w-8 h-8 flex items-center justify-center rounded-full shadow-md z-10"
        @click.stop="handleDelete"
      >
        <el-icon><CloseBold /></el-icon>
      </div>
    </div>

    <el-upload
      v-else
      action="#"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="handleFileChange"
      accept="image/*"
      class="w-full"
    >
      <div
        class="p-2 w-full aspect-[4/3] border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center bg-gray-50 active:bg-gray-200 transition-colors"
      >
        <el-icon :size="32" class="text-gray-400"><Camera /></el-icon>
      </div>
    </el-upload>

    <el-dialog
      v-model="previewVisible"
      title="照片预览"
      width="95%"
      align-center
      append-to-body
    >
      <img :src="modelValue" class="w-full" />
    </el-dialog>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { ref, onMounted } from "vue";
import { Camera, CloseBold } from "@element-plus/icons-vue";
import { idbGet, idbSet, idbDel } from "../utils/watermarkIdb";

const blobToDataUrl = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () =>
      reject(reader.error || new Error("Blob 转 DataURL 失败"));
    reader.readAsDataURL(blob);
  });

const props = defineProps({
  modelValue: String,
  cacheKey: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:modelValue"]);
const previewVisible = ref(false);

const handlePreview = () => {
  previewVisible.value = true;
};

const handleDelete = () => {
  emit("update:modelValue", "");
  if (props.cacheKey) {
    void idbDel(props.cacheKey).catch(() => {});
  }
};

const handleFileChange = async (uploadFile) => {
  const file = uploadFile.raw;
  if (!file) return;

  try {
    const dataUrl = await blobToDataUrl(file);
    emit("update:modelValue", dataUrl);
    if (props.cacheKey) {
      await idbSet(props.cacheKey, file);
    }
  } catch (error) {
    console.warn("读取或缓存原图失败:", error);
  }
};

onMounted(() => {
  if (!props.cacheKey || props.modelValue) return;

  void (async () => {
    try {
      const blob = await idbGet(props.cacheKey);
      if (!blob || props.modelValue) return;
      const dataUrl = await blobToDataUrl(blob);
      if (!props.modelValue) emit("update:modelValue", dataUrl);
    } catch (error) {
      console.warn("读取图片缓存失败:", error);
    }
  })();
});
</script>
